import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { inputPortalTokens } from "../../Input/tokens/Input.portal";
export var selectPortalTokens = _objectSpread(_objectSpread({}, inputPortalTokens), {}, {
  actionIcons: {
    colorBase: function colorBase(_ref) {
      var color = _ref.color;
      return color.fill.icon.base;
    },
    colorHover: function colorHover(_ref2) {
      var color = _ref2.color;
      return color.fill.icon.hover;
    },
    sizes: {
      s: {
        fontSize: 24
      },
      m: {
        fontSize: 24
      },
      l: {
        fontSize: 24
      }
    },
    separatorColor: function separatorColor(_ref3) {
      var color = _ref3.color;
      return color.border.input.base;
    },
    separatorMargins: {
      s: {
        x: 10,
        y: 2
      },
      m: {
        x: 10,
        y: 2
      },
      l: {
        x: 10,
        y: 2
      }
    }
  },
  chevronIconStyle: "chevron",
  selectAllUnderline: false,
  tag: {
    bgColor: function bgColor(_ref4) {
      var palette = _ref4.palette;
      return palette.neutralsBlack.hex10;
    },
    xIconColor: function xIconColor(_ref5) {
      var color = _ref5.color;
      return color.text.black.base;
    },
    xIconColorHover: function xIconColorHover(_ref6) {
      var palette = _ref6.palette;
      return palette.neutralsBlack.hex100;
    },
    sizes: {
      s: {
        fontVariant: "xs",
        tagHeight: 22,
        paddingLeft: 7,
        margin: 3,
        iconSize: 16,
        iconMarginLeft: 7,
        iconMarginRight: 7
      },
      m: {
        fontVariant: "s",
        tagHeight: 24,
        paddingLeft: 8,
        margin: 6,
        iconSize: 18,
        iconMarginLeft: 4,
        iconMarginRight: 8
      },
      l: {
        fontVariant: "m",
        tagHeight: 28,
        paddingLeft: 9,
        margin: 8,
        iconSize: 20,
        iconMarginLeft: 9,
        iconMarginRight: 9
      }
    }
  },
  wrapper: {
    sizes: {
      s: {
        minHeight: 32,
        paddingY: 3,
        paddingX: 10,
        borderRadius: 4
      },
      m: {
        minHeight: 40,
        paddingY: 6,
        paddingX: 12,
        borderRadius: 6
      },
      l: {
        minHeight: 48,
        paddingY: 8,
        paddingX: 14,
        borderRadius: 8
      }
    }
  },
  dropdown: {
    item: {
      sizes: {
        s: {
          paddingX: 14,
          paddingTop: 10,
          paddingBottom: 12
        },
        m: {
          paddingX: 14,
          paddingTop: 10,
          paddingBottom: 12
        },
        l: {
          paddingX: 14,
          paddingTop: 10,
          paddingBottom: 12
        }
      },
      emptyMsg: {
        paddingX: 14,
        paddingY: 8,
        color: function color(_ref7) {
          var _color = _ref7.color;
          return _color.text.placeholder.base;
        },
        fontVariant: "s"
      },
      colors: {
        text: function text(_ref8) {
          var color = _ref8.color;
          return color.text.black.base;
        },
        textOnDisable: function textOnDisable(_ref9) {
          var color = _ref9.color;
          return color.text.black.base;
        },
        bgHover: "rgba(7, 15, 72, 0.05)",
        bgSelectedSingle: function bgSelectedSingle(_ref10) {
          var palette = _ref10.palette;
          return palette.newBlue.hex5;
        },
        bgSelectedHoverSingle: "#CAD7F6",
        bgSelectedMulti: function bgSelectedMulti(_ref11) {
          var color = _ref11.color;
          return color.fill.item.base;
        },
        bgSelectedHoverMulti: "rgba(7, 15, 72, 0.05)",
        opacityOnDisable: 0.5
      },
      secondaryText: {
        paddingTop: 2,
        fontVariant: "xs",
        color: function color(_ref12) {
          var _color2 = _ref12.color;
          return _color2.text.secondary.base;
        }
      },
      icon: {
        marginRight: 10,
        color: function color(_ref13) {
          var _color3 = _ref13.color;
          return _color3.fill.icon.base;
        },
        fontSize: 24,
        textOffset: 2,
        opacityOnDisable: 1
      }
    },
    menuWrapper: {
      maxHeight: 300,
      borderRadius: 6,
      bgColor: function bgColor(_ref14) {
        var color = _ref14.color;
        return color.fill.item.base;
      },
      boxShadow: function boxShadow(_ref15) {
        var palette = _ref15.palette;
        return "0 1px 2px 2px ".concat(palette.neutralsBlack.rgba10);
      },
      paddingY: 10
    },
    groupTitle: {
      color: function color(_ref16) {
        var _color4 = _ref16.color;
        return _color4.text.placeholder.base;
      },
      fontVariant: "s",
      paddingY: 8
    },
    groupSeparator: {
      color: function color(_ref17) {
        var _color5 = _ref17.color;
        return _color5.border.hr.base;
      },
      height: 1,
      paddingY: 8
    }
  }
});